import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import { MenuBar, commandMenuEnhancer } from "@teselagen/ui";
import { compose } from "redux";
import { memoize } from "lodash-es";
import withEditorProps from "../withEditorProps";
import menuDef from "./defaultConfig";
import getCommands from "../commands";
import { Icon, Spinner } from "@blueprintjs/core";
const ident = (x) => x;
class OveMenuBar extends React.Component {
  constructor(props) {
    super(props);
    const commands = getCommands(this);
    window.oveMenuToastrSuccess = this.oveMenuToastrSuccess;
    this.enhancers = [
      commandMenuEnhancer(commands, {
        useTicks: true,
        omitIcons: true
      })
    ];
    this.counter = 0;
  }
  state = {
    // successMessage: "asdfasdf",
    // successMessageLoading: true
  };
  getFilteredMenu = memoize((menuFilter, menuDef2) => {
    this.counter++;
    if (this.counter === 50)
      console.warn(
        `It's likely you're passing a new "menuFilter" function every time. This will cause unecessary re-renders. Try not to recreate a new function each time!`
      );
    return menuFilter(menuDef2);
  });
  oveMenuToastrSuccess = (message, { loading } = {}) => {
    this.setState({ successMessage: message, successMessageLoading: loading });
    if (this.clearId) {
      clearTimeout(this.clearId);
    }
    this.clearId = setTimeout(() => {
      this.setState({ successMessage: "", successMessageLoading: false });
    }, 5e3);
  };
  render() {
    const { menuFilter = ident } = this.props;
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: "veMenuBarContainer",
        style: {
          display: "flex",
          width: "100%"
          /* height: "100%" */
        },
        children: /* @__PURE__ */ jsx(
          MenuBar,
          {
            extraContent: this.state.successMessage && /* @__PURE__ */ jsxs(
              "div",
              {
                className: "ove-menu-toast",
                style: {
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "auto",
                  marginRight: 10
                },
                children: [
                  this.state.successMessageLoading ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Spinner, { size: 15 }) }) : /* @__PURE__ */ jsx(Icon, { icon: "tick-circle", intent: "success" }),
                  " ",
                  "\xA0",
                  this.state.successMessage
                ]
              }
            ),
            menu: this.getFilteredMenu(menuFilter, menuDef),
            enhancers: this.enhancers
          }
        )
      }
    );
  }
}
export default compose(withEditorProps)(OveMenuBar);
